import { render, staticRenderFns } from "./UserTicketRowActions.vue?vue&type=template&id=30a48f9a"
import script from "./UserTicketRowActions.vue?vue&type=script&lang=js"
export * from "./UserTicketRowActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports